<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer/>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <div class="x-text-field">
                <label>知识产权名称</label>
                <div>{{ item.name }}</div>
              </div>
            </v-flex>
            <v-flex xs3>
              <div class="x-text-field">
                <label>知识产权类型</label>
                <div>{{ !item.type? "": item.type.name }}</div>
              </div>
            </v-flex>
            <v-flex xs3>
              <div class="x-text-field">
                <label>知识产权属地</label>
                <div>{{ affiliationMap[item.affiliation] }}</div>
              </div>
            </v-flex>
            <v-flex xs6>
              <div class="x-text-field">
                <label>归属部门</label>
                <div>{{ !item.department? "": item.department.name}}</div>
              </div>
            </v-flex>
            <v-flex xs6>
              <div class="x-text-field">
                <label>代理机构</label>
                <div>{{!item.agency? "": item.agency.name }}</div>
              </div>
            </v-flex>
            <v-flex xs12>
              <x-orgs-view
                label="归属单位列表"
                v-model="item.orgs"
                hint="申请人列表"
              />
            </v-flex>
            <v-flex xs12>
              <x-apps-view
                label="参与人列表"
                v-model="item.apps"
                hint="参与人列表"
              />
            </v-flex>
            <v-flex xs12>
              <div class="x-text-field">
                <label>专利来源</label>
                <div>{{item.source}}</div>
              </div>
            </v-flex>
            <v-flex xs12>
              <div v-if="item.attachments &&  item.attachments.length > 0">
                <p class="my-1">附件列表：</p>
                <v-divider/>
                <ol class="section-list">
                  <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                    <a :href="`/api/inte/file/${a.dbid}`" target="_blank" class="x-ellipsis">
                      {{a.fileName}}
                      ({{a.size | fileSize }})
                    </a>
                  </li>
                </ol>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import {mapGetters} from 'vuex'
  import mixin from '@/mixin'
  import XAppsView from './appsView'
  import XOrgsView from './orgsView'
  const  baseUri= '/api/inte/intellectualApp'

  export default {
    mixins: [mixin.view(baseUri)],
    components: {XAppsView,XOrgsView},
    data() {
      return {
        fileUri: '/api/inte/file',

        item: {},
        affiliationMap:{
          gn: "国内",
          gw: "国外"
        },
      }
    },
    computed: {
      ...mapGetters(['funcIds']),
    },
  }
</script>
